module.exports = __webpack_public_path__ + "static/media/horizontallogo.8d33edcd.png";